// fork overlay: fork-owned extension of OSS v4.14.0 (blob:1b1282ae6a75fb6a)
//
// Mirrors app/javascript/dashboard/i18n/locale/pt_BR/index.js shape (42 OSS sibling
// imports + ./fork.json + ./deep-merge.js). Vite fork overlay plugin redirects
// `app/javascript/dashboard/i18n/locale/pt_BR/index.js` → this file at build time.
//
// WHY alias-form OSS imports: Relative `./foo.json` from this fork dir would
// resolve into fork/ (where OSS siblings don't exist). Alias `dashboard/...`
// expands through vite.config aliases to the OSS path; fork-overlay plugin then
// checks for a fork override and falls through to OSS when none exists. See
// CLAUDE.md Critical Lesson #2 (D-07).
//
// WHY deep-merge: object-spread would wipe nested OSS keys when the fork
// declares a parent path. deepMerge walks recursively and only overwrites
// scalars + arrays.
import advancedFilters from 'dashboard/i18n/locale/pt_BR/advancedFilters.json';
import agentBots from 'dashboard/i18n/locale/pt_BR/agentBots.json';
import agentMgmt from 'dashboard/i18n/locale/pt_BR/agentMgmt.json';
import attributesMgmt from 'dashboard/i18n/locale/pt_BR/attributesMgmt.json';
import auditLogs from 'dashboard/i18n/locale/pt_BR/auditLogs.json';
import automation from 'dashboard/i18n/locale/pt_BR/automation.json';
import bulkActions from 'dashboard/i18n/locale/pt_BR/bulkActions.json';
import campaign from 'dashboard/i18n/locale/pt_BR/campaign.json';
import cannedMgmt from 'dashboard/i18n/locale/pt_BR/cannedMgmt.json';
import chatlist from 'dashboard/i18n/locale/pt_BR/chatlist.json';
import companies from 'dashboard/i18n/locale/pt_BR/companies.json';
import components from 'dashboard/i18n/locale/pt_BR/components.json';
import contact from 'dashboard/i18n/locale/pt_BR/contact.json';
import contactFilters from 'dashboard/i18n/locale/pt_BR/contactFilters.json';
import contentTemplates from 'dashboard/i18n/locale/pt_BR/contentTemplates.json';
import conversation from 'dashboard/i18n/locale/pt_BR/conversation.json';
import csatMgmt from 'dashboard/i18n/locale/pt_BR/csatMgmt.json';
import customRole from 'dashboard/i18n/locale/pt_BR/customRole.json';
import datePicker from 'dashboard/i18n/locale/pt_BR/datePicker.json';
import emoji from 'dashboard/i18n/locale/pt_BR/emoji.json';
import general from 'dashboard/i18n/locale/pt_BR/general.json';
import generalSettings from 'dashboard/i18n/locale/pt_BR/generalSettings.json';
import helpCenter from 'dashboard/i18n/locale/pt_BR/helpCenter.json';
import inbox from 'dashboard/i18n/locale/pt_BR/inbox.json';
import inboxMgmt from 'dashboard/i18n/locale/pt_BR/inboxMgmt.json';
import integrationApps from 'dashboard/i18n/locale/pt_BR/integrationApps.json';
import integrations from 'dashboard/i18n/locale/pt_BR/integrations.json';
import labelsMgmt from 'dashboard/i18n/locale/pt_BR/labelsMgmt.json';
import login from 'dashboard/i18n/locale/pt_BR/login.json';
import macros from 'dashboard/i18n/locale/pt_BR/macros.json';
import mfa from 'dashboard/i18n/locale/pt_BR/mfa.json';
import onboarding from 'dashboard/i18n/locale/pt_BR/onboarding.json';
import report from 'dashboard/i18n/locale/pt_BR/report.json';
import resetPassword from 'dashboard/i18n/locale/pt_BR/resetPassword.json';
import search from 'dashboard/i18n/locale/pt_BR/search.json';
import setNewPassword from 'dashboard/i18n/locale/pt_BR/setNewPassword.json';
import settings from 'dashboard/i18n/locale/pt_BR/settings.json';
import signup from 'dashboard/i18n/locale/pt_BR/signup.json';
import sla from 'dashboard/i18n/locale/pt_BR/sla.json';
import snooze from 'dashboard/i18n/locale/pt_BR/snooze.json';
import teamsSettings from 'dashboard/i18n/locale/pt_BR/teamsSettings.json';
import webhooks from 'dashboard/i18n/locale/pt_BR/webhooks.json';
import whatsappTemplates from 'dashboard/i18n/locale/pt_BR/whatsappTemplates.json';
import yearInReview from 'dashboard/i18n/locale/pt_BR/yearInReview.json';
import forkKeys from './fork.json';
import deepMerge from './deep-merge.js';

// Build the flat OSS locale map first, then deep-merge every fork.json
// namespace (INBOX_MGMT, CAMPAIGN, …) onto it. Merging AFTER the spread means
// each fork top-level key lands in its OSS sibling instead of one hard-coded
// target, so a new fork namespace can no longer clobber an unrelated one
// (e.g. CAMPAIGN must not replace the OSS campaign tree).
const messages = {
  ...advancedFilters,
  ...agentBots,
  ...agentMgmt,
  ...attributesMgmt,
  ...auditLogs,
  ...automation,
  ...bulkActions,
  ...campaign,
  ...cannedMgmt,
  ...chatlist,
  ...companies,
  ...components,
  ...contact,
  ...contactFilters,
  ...contentTemplates,
  ...conversation,
  ...csatMgmt,
  ...customRole,
  ...datePicker,
  ...emoji,
  ...general,
  ...generalSettings,
  ...helpCenter,
  ...inbox,
  ...inboxMgmt,
  ...integrationApps,
  ...integrations,
  ...labelsMgmt,
  ...login,
  ...macros,
  ...mfa,
  ...onboarding,
  ...report,
  ...resetPassword,
  ...search,
  ...setNewPassword,
  ...settings,
  ...signup,
  ...sla,
  ...snooze,
  ...teamsSettings,
  ...webhooks,
  ...whatsappTemplates,
  ...yearInReview,
};

export default deepMerge(messages, forkKeys);
